import React from "react";
import PropTypes from "prop-types";
import { Switch as MuiSwitch, FormControlLabel } from "@mui/material";

import "./Switch.scss";

const Switch = ({
  label,
  checked,
  onChange,
  id,
  name,
  required,
  disabled,
  color,
  labelPlacement,
  labelClass,
  switchClass,
  wrapperClass,
  formLabelClass,
  hintLabel,
}) => {
  return (
    <div className={`${wrapperClass} switch-container`}>
      <FormControlLabel
        control={
          <MuiSwitch
            id={id || name}
            name={name}
            color={color}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            required={required}
            className={switchClass}
          />
        }
        label={
          <div className="switch-label-container">
            <span className={`${labelClass} switch-label fsize-16 fweight-500`}>{label}</span>
            {hintLabel && <span className="hint-label fsize-12">{hintLabel}</span>}
          </div>
          }
       
        labelPlacement={labelPlacement}
        disabled={disabled}
        className={formLabelClass}
      />
    </div>
  );
};

export default Switch;

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disabled: PropTypes.bool,
  color: PropTypes.string,
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  labelClass: PropTypes.string,
  switchClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  formLabelClass: PropTypes.string,
  hintLabel: PropTypes.string,
};

Switch.defaultProps = {
  labelPlacement: "start",
  color: "primary",
};
